import { Routes } from '@angular/router';

import { DashboardComponent}              from './dashboard.component';
import { AllUsersComponent}               from './all-users/all-users.component';
import { ProgramComponent }               from './program-list/program/program.component';
import { FieldManualsComponent }          from './program-list/program/field-manuals/field-manuals.component';
import { AnalyticsComponent }             from './program-list/program/analytics/analytics.component';
import { GroupComponent }                 from './program-list/program/groups/group/group.component';
import { GroupShellComponent }            from './program-list/program/groups/group-shell/group-shell.component';
import { UsersComponent }                 from './program-list/program/groups/users/users.component';
import { SessionsComponent }              from './program-list/sessions/sessions.component';
import { SessionComponent }               from './program-list/sessions/session/session.component';
import { ProgramWithSessionsComponent }   from './program-list/program-with-sessions/program-with-sessions.component';
import { SessionTeamUsersComponent }      from './program-list/sessions/session/session-team-users/session-team-users.component';
import { GuideComponent }                 from './guides/guide/guide.component';
import { JourneysComponent }              from './journeys/journeys.component';
import { JourneyComponent }               from './journeys/journey/journey.component';
import { ProgramSettingsComponent }       from './program-list/program/program-settings/program-settings.component';
import { RecentActivityComponent }        from './program-list/program/recent-activity/recent-activity.component';
import { GroupSettingsComponent }         from './program-list/program/groups/group/group-settings/group-settings.component';
import { PermissionsRouteGuard }          from '../app-guards';
import { CheckForSimplifiedSessionManagement, CheckForSimplifiedSessionManagementChild } from './guards';

export const dashboardRoutes: Routes = [
  { path: '',
    component: DashboardComponent,
    canActivate: [CheckForSimplifiedSessionManagement]
  },
  { path: 'guides/:id', component: GuideComponent },
  {
    path: 'journeys',
    component: JourneysComponent,
  },
  {
    path: 'journeys/journey/:journeyId',
    component: JourneyComponent,
  },
  {
    path: 'entity-users', // AXA specific for now
    component: AllUsersComponent,
    canActivateChild: [PermissionsRouteGuard],
  },
  {
    path: 'new-programs', // Update path when removing old program views
    component: SessionsComponent,
    canActivateChild: [PermissionsRouteGuard],
  },
  {
    path: 'new-programs/:programId', // Update path when removing old program views
    component: ProgramWithSessionsComponent
  },
  {
    path: 'new-programs/:programId/sessions/:sessionId', // Update path when removing old program views
    component: SessionComponent
  },
  {
    path: 'new-programs/:programId/sessions/:sessionId/teams/:groupId', // Update path when removing old program views
    component: SessionTeamUsersComponent
  },
  {
    path: 'programs/:id',
    component: ProgramComponent,
    canActivateChild: [PermissionsRouteGuard, CheckForSimplifiedSessionManagementChild],
    children: [
      {
        path: '',
        redirectTo: 'teams',
        pathMatch: 'full'
      },
      {
        path: 'teams',
        component: GroupComponent,
      },
      {
        path: 'content',
        component: FieldManualsComponent,
        data: {
          requiredRole: 'nomadicAdministration'
        }
      },
      {
        path: 'teams/:groupId',
        component: GroupShellComponent,
        children: [
          {
            path: '',
            redirectTo: 'users',
            pathMatch: 'full'
          },
          {
            path: 'users',
            component: UsersComponent
          },
          {
            path: 'general-settings',
            component: GroupSettingsComponent,
            data: {
              settings: 'general-settings'
            }
          },
          {
            path: 'schedule',
            component: GroupSettingsComponent,
            data: {
              settings: 'schedule'
            }
          },
          {
            path: 'notifications',
            component: GroupSettingsComponent,
            data: {
              settings: 'notifications'
            }
          },
        ],
        data: {
          currentLevel: 1
        }
      },
      {
        path: 'waves/:groupId',
        component: GroupShellComponent,
        children: [
          {
            path: '',
            redirectTo: 'teams',
            pathMatch: 'full'
          },
          {
            path: 'teams',
            component: GroupComponent,
          },
          {
            path: 'teams/:groupId',
            component: GroupShellComponent,
            children: [
              {
                path: '',
                redirectTo: 'users',
                pathMatch: 'full'
              },
              {
                path: 'users',
                component: UsersComponent
              },
              {
                path: 'general-settings',
                component: GroupSettingsComponent,
                data: {
                  settings: 'general-settings'
                }
              },
              {
                path: 'schedule',
                component: GroupSettingsComponent,
                data: {
                  settings: 'schedule'
                }
              },
              {
                path: 'notifications',
                component: GroupSettingsComponent,
                data: {
                  settings: 'notifications'
                }
              },
            ],
            data: {
              currentLevel: 2
            }
          },
          {
            path: 'general-settings',
            component: GroupSettingsComponent,
            data: {
              settings: 'general-settings'
            }
          },
          {
            path: 'schedule',
            component: GroupSettingsComponent,
            data: {
              settings: 'schedule'
            }
          },
          {
            path: 'notifications',
            component: GroupSettingsComponent,
            data: {
              settings: 'notifications'
            }
          },
        ],
        data: {
          currentLevel: 1
        }
      },
      {
        path: 'appearance',
        component: ProgramSettingsComponent,
        data: {
          settings: 'appearance',
          requiredRole: 'nomadicAdministration'
        }
      },
      {
        path: 'admins',
        component: ProgramSettingsComponent,
        data: {
          settings: 'admins'
        }
      },
      {
        path: 'other-settings',
        component: ProgramSettingsComponent,
        data: {
          settings: 'other-settings'
        }
      },
      {
        path: 'analytics',
        component: AnalyticsComponent
      },
      {
        path: 'changes',
        component: RecentActivityComponent,
        data: {
          requiredRole: 'nomadicAdministration'
        }
      }
    ],
    data: {
      currentLevel: 0
    }
  }
];



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/dashboard-routes.ts